import { Box } from "@mui/system";
import { FileViewerDialogInitValues } from "../FileViewerDialog";

import type { JSX } from "react";

export type PhotoViewerProps = FileViewerDialogInitValues;

export function PhotoViewer({
    title,
    url,
    mimeType
}: PhotoViewerProps): JSX.Element {
    return (

        <Box style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", height: "100%" }}>
            <img
                src={url}
                alt={title}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain"
                }} />
        </Box>
    );
}